module.exports = "/packs/images/homepage/facilities/health_check~9dfe69aa2ec893f1359ef550b76079c9.jpg";